import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Form, Table, Image } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";


const AddSubCategory = ({ showModal, handleClose, fetchAllSubCategory }) => {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [categoryOption, setCategoryOption] = useState([]);


    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    const getAllCategory = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllCategory",
        });

        const output = response.data;

        if (output.length > 0) {
            setCategoryOption(
                output.map((option) => ({
                    value: option.pk_cat_key,
                    label: option.cat_name,
                }))
            );
        }
    };

    useEffect(() => {
        getAllCategory();
    }, []);

    const initialValues = {
        subcat_name: "",
        subcat_description: "",
        fk_cat_key: "",
        created_by: sessionStorage.getItem("pk_user_key"),
    };

    const basicSchema = Yup.object().shape({
        subcat_name: Yup.string()
            .required("Sub Category Name is required.")
            .test("no-leading-space", "No spaces allowed at the beginning.", function (value) {
                if (!value) return true;
                return !/^\s/.test(value);
            })
            .matches(/^[a-zA-Z0-9\s]*$/, "Special characters are not allowed.")
            .min(3, "Category Name must be at least 3 characters.")
            .max(250, "Category Name must be at most 250 characters.")
            .test("no-trailing-space", "No spaces allowed at the end.", function (value) {
                if (!value) return true;
                return !/\s$/.test(value);
            })
            .test("no-numbers", "Sub Category Name should not contain numbers.", function (value) {
                if (!value) return true;
                return !/\d/.test(value);
            })
            .test("unique-link", "Sub Category Name is already existing in the database", async function (value) {
                if (!value) return true;
                return await checkSubCategoryName(value);
            })
            .strict(),

        subcat_description: Yup.string()
            .required("Sub Category Description is required.")
            .test("no-leading-space", "No spaces allowed at the beginning.", function (value) {
                if (!value) return true;
                return !/^\s/.test(value);
            })
            .matches(/^[a-zA-Z0-9\s]*$/, "Special characters are not allowed.")
            .min(10, "Sub Category Description must be at least 10 character.")
            .max(250, "Sub Category Description must be at most 250 characters.")
            .test("no-trailing-space", "No spaces allowed at the end.", function (value) {
                if (!value) return true;
                return !/\s$/.test(value);
            })
            .strict(),
        fk_cat_key: Yup.string().required("Category is required."),
    });

    async function checkSubCategoryName(subcat_name) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkSubCategoryName",
            subcat_name: subcat_name,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "addSubCategory",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                resetFormFields(resetForm, setValues, initialValues);
                handleClose();
                fetchAllSubCategory();
                toast.success("Added successfully!", {
                    autoClose: 3000,
                });
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;
    return (
        <>
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Sub Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit} ref={formRef}>

                        <Form.Group controlId="subcat_name" className="mb-3">
                            <Form.Label>
                                Sub Category Name <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Form.Control type="text" value={values.cat_name} onChange={handleChange} onBlur={handleBlur} placeholder="Enter sub category name" />
                            {errors.subcat_name && touched.subcat_name && <p className="text-danger">{errors.subcat_name}</p>}
                        </Form.Group>
                        <Form.Group controlId="subcat_description" className="mb-3">
                            <Form.Label>
                                Description <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                // type="text"
                                as="textarea"
                                rows={3}
                                value={values.subcat_description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter sub category description"
                            />
                            {errors.subcat_description && touched.subcat_description && <p className="text-danger">{errors.subcat_description}</p>}
                        </Form.Group>

                        <Form.Group controlId="fk_cat_key" className="w-100 w-sm-100">
                            <Form.Label>
                                Select Category <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Select
                                options={categoryOption}
                                id="fk_cat_key"
                                name="fk_cat_key"
                                value={categoryOption.find(
                                    (option) => option.value && values.fk_cat_key && option.value.toString() === values.fk_cat_key.toString()
                                )}
                                onChange={(selectedOption) => {
                                    const event = {
                                        target: {
                                            name: "fk_cat_key",
                                            value: selectedOption["value"],
                                        },
                                    };
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    setTouched({ ...touched, fk_cat_key: true });
                                }}
                            />

                            {errors.fk_cat_key && touched.fk_cat_key && <p className="text-danger">{errors.fk_cat_key}</p>}
                        </Form.Group>

                        <div className="mt-3">
                            <Button variant="dark" type="submit" disabled={isSubmitting}>
                                Add Sub Category
                            </Button>
                            <Button variant="outline-secondary" className="ms-2" onClick={handleClose}>
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddSubCategory;
